import { create } from 'zustand';

const useLoyaltyStore = create((set) => ({
  // Backfill progress
  backfillCustomerId: null,
  backfillStatus: 'idle', // 'idle' | 'running' | 'done' | 'error'
  backfillResult: null,
  backfillError: null,

  setBackfillCustomer: (id) => set({ backfillCustomerId: id, backfillStatus: 'idle', backfillResult: null, backfillError: null }),
  setBackfillRunning: () => set({ backfillStatus: 'running' }),
  setBackfillDone: (result) => set({ backfillStatus: 'done', backfillResult: result }),
  setBackfillError: (err) => set({ backfillStatus: 'error', backfillError: err }),
  resetBackfill: () => set({ backfillCustomerId: null, backfillStatus: 'idle', backfillResult: null, backfillError: null }),
}));

export default useLoyaltyStore;
